<template>
  <div class="time-monitor" v-if="monitorList.length">
    <div class="wrap">
      <live-video v-for="(item,index) in videoList" :key="index" :url="item.url" :index="index"  @error="changeError"/>
      <!-- <live-video v-for="(item,index) in videoList" :key="index" :url="item.url" :index="index"  @error="changeError"/> -->
    </div>
    <!-- <Button @click="monitorInit">aa</Button> -->
    <section class="page"><span class="up" @click="up" :class="{pageturn:this.page==0}" >上一页</span><span @click="down" class="down"  :class="{pageturn:this.page==this.total}" >下一页</span></section>
  </div>
  <div v-else-if="monitorList.length==0&&isLoad" class="time-monitor">
    <div class="wrap" style="position:relative">
      <div class="nodata" v-for="(item,index) in list" :key="index">
        <div class="mask">
          <span class="word">暂无监控设备，请联系管理员添加</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indexModule from '../../store/modules/index'
import { mapMutations, mapActions, mapState } from 'vuex'
import LiveVideo from '../common/LiveVideo'
export default {
  name: 'TimeMonitor',
  data () {
    return {
      list: ['http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/2017092513417/dev_20170925133417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_20170925133417_itq70exptp5sa70.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8'],
      monitorList: [],
      videos: [],
      pageNum: 6,
      page: 0,
      total: '',
      nodata: '',
      isLoad: false
    }
  },
  watch: {
    async haveVideoBaseId (value) {
      this.page = 0
      this.monitorList = []
      this.isLoad = false
      await this.getVideoMonitoring(this.haveVideoBaseId)
      this.monitorList = JSON.parse(JSON.stringify(this.videoMonitor))
      console.log(this.monitorList)
      if (this.monitorList.length === 0) {
        this.nodata = true
      }
      setTimeout(() => {
        this.isLoad = true
      }, 1000)

      this.total = Math.ceil(this.monitorList.length / this.pageNum) - 1
      this.setMonitor(this.monitorList.length)
    }
  },
  async mounted () {
    console.log(12, window.screen.width, window.screen.height)
    if (window.screen.width <= 1366) {
      this.pageNum = 9
    } else {
      this.pageNum = 6
    }
    this.monitorList = []
    this.page = 0
    // if (this.haveVideoBaseId) {
    await this.getVideoMonitoring(this.haveVideoBaseId)
    // }
    this.monitorList = JSON.parse(JSON.stringify(this.videoMonitor))
    console.log(this.monitorList)
    if (this.monitorList.length === 0) {
      this.nodata = true
    }
    setTimeout(() => {
      this.isLoad = true
    }, 1000)
    // this.isLoad = true
    this.total = Math.ceil(this.monitorList.length / this.pageNum) - 1
    this.setMonitor(this.monitorList.length)
  },
  computed: {
    ...mapState(indexModule, ['videoMonitor']),
    ...mapState(indexModule, ['haveVideoBaseId']),
    videoList () {
      var arr = this.monitorList.map(item => {
        var newItem = {
          showLogo: false,
          url: item
        }
        return newItem
      })
      return arr.slice(this.page * this.pageNum, (this.page + 1) * this.pageNum)
    }
  },
  methods: {
    ...mapMutations(indexModule, ['setMonitor']),
    ...mapActions(indexModule, ['getVideoMonitoring']),
    changeError (num) {
      // console.log(1)
      // this.videoList.push(this.videoList.splice(num, 1)[0])
      // // this.videoList.splice(num, 1)
    },
    splitArr (arr, num) {
      let result = []
      this.total = Math.ceil(arr.length / num)
      for (let i = 0; i < this.total; i++) {
        var start = i * num
        var end = start + num
        result.push(arr.slice(start, end))
      }
      return result
    },
    up () {
      let value = this.page - 1
      this.page = -1
      this.$nextTick(() => {
        if (value < 0) {
          this.page = 0
        } else {
          this.page = value
        }
      })
    },
    down () {
      let value = this.page + 1
      this.page = -1
      this.$nextTick(() => {
        if (value > this.total) {
          this.page = this.total
        } else {
          this.page = value
        }
      })
    }
  },
  components: {
    LiveVideo
  }
}
</script>
<style lang="stylus">

.pageturn{
  pointer-events :none;
  color:grey !important;
}
.nodata{
  height:100%;
  width :100%;
  font-size:20px;
  color:#eee;
  align-items: center;
  justify-content: center;
  background: url('../../../public/images/video_def_2.png') no-repeat
  background-size:100% 100%;
}
.mask{
  position:absolute;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background:rgba(0,0,0,.6);
  display:flex;
  align-items:center;
  justify-content:center;
}
.word{
  color:#fff;
 font-size :18px;
}

.page{
  position absolute
  z-index 3
  width 100%;
  margin: 25px auto 0;
  // left:0;
  bottom 0px;

  font-size:16px;
  text-align:center;
  color:#fff;
  span{
    cursor pointer
  }
}
</style>
<style lang="stylus" scoped>
  .nodata{
    height:100%;
    width :100%;
    font-size:20px;
    line-height:1.3;
    color:#eee;
    text-align: center;

    // padding:70px 30px 0 30px;
    background: url('../../../public/images/video_def_2.png') no-repeat
    background-size:100% 100%;
  }
  .time-monitor
    position relative;
    @media screen and (min-width: 1500px) and (max-width: 1920px) {
      .wrap{
        height 850px !important
        >div{
          position relative
          flex 0 0 33.33%
          height 50%
        }
      }
    }
    @media screen and (min-width: 1365px) and (max-width: 1400px) {
      .wrap{
        height 640px !important
        >div{
          position relative
          flex 0 0 33.33%
          height 33.33%
        }
      }
    }
    display: flex;
    flex 1
    flex-wrap :wrap;
    flex-direction column
    // height 100%
    margin-right 8px
    flex-direction: column;
    // background #619179;
    .up
      margin-right 40px
      color #fff
    .wrap
      position relative
      display flex
      flex-wrap wrap

      justify-content center
      justify-content flex-start
      // max-height 576px;
      // height 100%
      padding-bottom:45px;

      height 630px
      overflow hidden
      .page
        position absolute
        z-index 3
        left:0;
        bottom 0;

      // >div
      //   position relative
      //   flex 0 0 33.33%
      //   height  33.33%
      .video-js
        // flex 0 0 33.33%
        // height 50%
        width 100%;
        height 100%;
      .video-js .vjs-tech
        height: 100%;
      video
        width 100%
        // height 100%
        // object-fit fill   // 自动填充慢父div的大小 不受默认比列所影响
</style>
